const apiString = 'https://kprocessos.kintelligence.com.br';
//const apiString = 'http://localhost:3000';

export default apiString;